
import { useSelector,useDispatch } from 'react-redux'
import VideoView from './VideoView';
import RejoinButton from '../helperforall/RejoinButton';
import ToolsView from './ToolsView';
//import { SignToolsView }from './SignToolsView';
//import { SignStapelToolsView } from './SignStapelToolsView';
import { ShowLogs } from './ShowLogs';
import { ShowUserOnline } from './helper/ShowUserOnline';



import { Grid,Container, Group, Alert, createStyles, Loader,Text, Paper } from '@mantine/core';
import { InfoCircle } from 'tabler-icons-react';
import intl from 'react-intl-universal';
import { useEffect } from 'react';

const useStyles = createStyles((theme) => ({
  contbg: {
    backgroundColor: "#ffffff",	
    
  },
  borderbot: {
    borderBottomWidth: 2,
    borderBottomStyle: "solid",
    borderBottomColor: "#dee2e6",
  },
  loaderback: {	
    vheight: `80vh`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    minHeight: "80vh",
    minWidth: "50vw",
    position: "relative",
  },
  paper: { 
    minWidth: 400,
  },
  fixedbar: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    zIndex: 200, // Adjust z-index as needed
  },
  activloadermargin: {
    marginTop: "86px",
  },
  
}));


const NotarDash = () => {
  const { classes } = useStyles();
const dispatch = useDispatch()
const displaytyp: number = useSelector((state: any) => state.user.displaytyp )
const meuser = useSelector((state: any) => state.user.meuser)
const leftmeeting = useSelector((state: any) => state.user.leftmeeting)
const cmslink = useSelector((state: any) => state.user.cmslink)
const inithasloaded = useSelector((state: any) => state.user.inithasloaded)
const showlogs = useSelector((state: any) => state.user.showlogs)
const showonlinebar = useSelector((state: any) => state.user.showonlinebar)
const initsync = useSelector((state: any) => state.user.initsync)
const meetinginfo = useSelector((state: any) => state.user.meetinginfo)

const changelanguage = useSelector((state: any) => state.user.changelanguage)

const temppdfurl = useSelector((state: any) => state.user.temppdfurl)
//const signisstapel = useSelector((state: any) => state.user.signisstapel)

  //console.log("temppdfurl",temppdfurl)

const icon = <InfoCircle />;
let joinlink = cmslink.joinLink


useEffect(() => {
  
// SignalR Send Refresh Documets zu DRN 
        // @ts-ignore 
      const refreshdocspayload ={
          drnId: meetinginfo.drnId,
      }
      //console.log(refreshdocspayload)
      dispatch({ type: 'SIGNALR_GET_REFRESHDOCS', payload: refreshdocspayload});
    // eslint-disable-next-line react-hooks/exhaustive-deps
// Listen to SignalR Updates
const signalrActions = [
  { type: 'SIGNALR_UPDATE_USERDATA', eventName: "OnChangeParticipantStatus_" + meuser.userId },
  { type: 'SIGNALR_CONFIRM_USERDATA', eventName: "OnConfirmUserIdentity" },
  { type: 'SIGNALR_CHANGEMEETING_STATUSUSER', eventName: "OnChangeParticipantStatus_" + meuser.userId },
  { type: 'SIGNALR_ALLLEFT_STATUSUSER', eventName: "OnAllLeft" },
  { type: 'SIGNALR_RECIVEREJOINMEETINGLINK', eventName: "OnGetCapsuleLink" },
  { type: 'SIGNALR_RECIVEDOCUPDATE', eventName: "OnDocumentsLoaded" },
  { type: 'SIGNALR_RECIVEOPENDOC', eventName: "OnOpenDocumentForSign" },
  { type: 'SIGNALR_RECIVECONFDOC', eventName: "OnConfirmUserSignature" },
  { type: 'SIGNALR_RECIVECONFSTAPELDOC', eventName: "OnConfirmUserSignatureStapel" },
  { type: 'SIGNALR_RECIVEONHANDLEDOCUMENT', eventName: "OnHandleDocument" },
  { type: 'SIGNALR_RECIVE_ONPREPAREDOCUMENTS', eventName: "OnPrepareDocuments" },
  { type: 'SIGNALR_RECIVE_ONUPDATEMEETINGANDPARTICIPANTSDATA', eventName: "OnUpdateMeetingAndParticipantsData" },
  { type: 'SIGNALR_RECIVE_ONSETDOCUMENTSISREADOUT', eventName: "OnSetDocumentIsReadOut" },
  { type: 'SIGNALR_RECIVE_ONSETDOCUMENTISSIGNEDBYAll', eventName: "OnSetDocumentIsSignedByAll" },
  { type: 'SIGNALR_RECIVE_TAKENSCREENSHOT', eventName: "OnTakeSnapshot" },
  { type: 'SIGNALR_REMOVE_SCREENSHOT', eventName: "OnDeleteSnapshot" },
  { type: 'SIGNALR_INIT_SCREENSHOTDATA', eventName: "OnGetSnapshotsByDrnId" },
  { type: 'SIGNALR_UPDATEMEETINGDATA', eventName: "OnUpdateMeetingDate" },
  { type: 'SIGNALR_RECIVE_MEETINGLOGS', eventName: "OnGetMeetingLogs" },
  { type: 'SIGNALR_RECIVE_REFRESH_DOCS', eventName: "OnRefreshDocumentsFolder" },
  { type: 'SIGNALR_RECIVE_ONUPDATE_DOCS_FOLDERFROMDRN', eventName: "OnUpdateDocumentsFolderFromDrn" },   
  { type: 'SIGNALR_RECIVE_ONUPDATE_SIGS_STATUSUPDATE', eventName: "OnDocumentSignatureStatusUpdate" }, 
  { type: 'SIGNALR_ONUPDATESTAPELSIGNATURE', eventName: "OnUpdateStapelSignature" },
  { type: 'SIGNALR_RECIVE_IDAUSTRIA_DATA', eventName: "OnRequestIdAustriaIdentification" },
  { type: 'SIGNALR_RECIVE_IDAUSTRIA_DATAFULL', eventName: "OnParticipantIdAustriaData" },
  { type: 'SIGNALR_RECIVE_IDAUSTRIA_IDAUSTRIAOK', eventName: "OnSetIdAustriaConformation" },
  { type: 'SIGNALR_RECIVE_ALIAS_DATA', eventName: "OnChangeNotarFirstAndLastName" },
  { type: 'SIGNALR_RECIVE_CONFIRM_DRN_IDA', eventName: "OnParticipantIdAustriaClientResponse" },
  { type: 'SIGNALR_RECIVE_CONFIRM_PDFCONVERT', eventName: "OnTryToConvertPdfToA1bFormat" },
  { type: 'SIGNALR_RECIVE_PARTICIPANTSTOBEIDENTIFIED', eventName: "OnSetParticipantsToBeIdentified" },
  { type: 'SIGNALR_CLOSEVK_IN_DRN', eventName: "OnCloseVideoConverenceFromDrnSide" },
  { type: 'SIGNALR_RECIVESETUSERFORSIGBLOCKSETUP', eventName: "OnPrepareSignatureLayoutByDocument" },
  { type: 'SIGNALR_RECIVESETDOCUMENTISSIGPREPARED', eventName: "OnSetDocumentIsSigPrepared" },
  { type: 'SIGNALR_ONDELETESIGNATURELAYOUT', eventName: "OnDeleteSignatureLayoutByDocument" },
  { type: 'SIGNALR_ON ARCHIVEDMEETING', eventName: "OnArchivedMeeting" },
  { type: 'SIGNALR_RECIVEONINVITEGURSTFROMVK', eventName: "OnInviteGuestFromVk" },
  { type: 'SIGNALR_ONBLOCKGUESTFROMVK', eventName: "OnBlockGuestFromVk" },
  { type: 'SIGNALR_ONREINVITEGUESTFROMVK', eventName: "OnReInviteGuestsFromVk" },
  //{ type: 'SIGNALR_RECIVE_OPEN_CLOSE_DOCUMENT_SHARED_LINK', eventName: "OnOpenCloseDocumentSharedLink" }, 
  { type: 'SIGNALR_RECIVE_OC_DOCUMENT_SL_STAPEL', eventName: "OnOpenCloseStapelSharedLink" },
  { type: 'SIGNALR_RECIVE_OC_DOCUMENT_SL', eventName: "OnOpenCloseDocumentSharedLink" },
  { type: 'SIGNALR_RECIVESHAREDSIGNDOCSTATUS', eventName: "OnDocumentSingleSignatureStatusUpdate" }, 
  { type: 'SIGNALR_ONCREATESTAPEL', eventName: "OnCreateStapel" },
  { type: 'SIGNALR_ONUPDATESTAPEL', eventName: "OnUpdateStapel" },
  { type: 'SIGNALR_ONREMOVESTAPEL', eventName: "OnRemoveStapel" },
  { type: 'SIGNALR_RECIVE_STAPEL_SIG_PREPARED', eventName: "OnSetSignaturePreparationStatus" },
  { type: 'SIGNALR_RECIVE_STAPEL_SETUPCLOSE', eventName: "OnCloseStapelEditFrame" },
  { type: 'SIGNALR_RECIVE_GETADDUSER_FROMDRN', eventName: "OnGetAddParticipantPopupLink" },
   
  //{ type: 'SIGNALR_RECIVEOPENDOC_STAPEL', eventName: "OnOpenCloseStapelForSign" },

  
];

signalrActions.forEach(action => {
  dispatch({ type: action.type, eventName: action.eventName });
});

// eslint-disable-next-line react-hooks/exhaustive-deps
},[])
 

if (!initsync) { 
  return (
    <div className={classes.loaderback}>
                     <Paper shadow="sm" p="xl" className={classes.paper}>
                       <Group>
                        <Loader color="green" size="xl" />
                        <Text>{intl.get('LOADER_SYNC')} </Text>
                        </Group>
                    
                    </Paper>
                    </div>
  )
 }

//console.log("Dash changelanguage", changelanguage) 
//console.log("Dash Joinlink", joinlink) 

let mdwidthv = 9
let mdwidtht = 3

if (temppdfurl !== ""){
  mdwidthv = 11
  mdwidtht = 1
}



 
return (
    <>
    {showonlinebar &&
    <div className={classes.fixedbar}>
    <Container className={classes.contbg} fluid>
       <Grid  className={classes.borderbot}>
       <Grid.Col xs={12} sm={12} md={12}  ><ShowUserOnline /></Grid.Col>
       </Grid>
    </Container>
    </div>
    } 
    {displaytyp  === 1 && 
    <Container className={classes.contbg} fluid>
    <Grid className={showonlinebar ? classes.activloadermargin : ''}>
      <Grid.Col xs={12} sm={12} md={mdwidthv}  > 
            {!leftmeeting && joinlink && 
              <VideoView showlogs={showlogs}/>
            }
            {changelanguage && joinlink === undefined &&
              <RejoinButton />
            }
            {leftmeeting && joinlink === undefined && !changelanguage &&
                  <RejoinButton />
            }
            {showlogs &&
               <ShowLogs />
            }
    </Grid.Col>
    <Grid.Col xs={12} sm={12} md={mdwidtht} > 
       {inithasloaded && temppdfurl === "" &&  
          <ToolsView />
       }

      {/*
      {inithasloaded && temppdfurl !== "" && !signisstapel &&
          <SignToolsView />
      }
      {inithasloaded && temppdfurl !== "" && signisstapel &&
          <SignStapelToolsView />
       }
      */}     



       {!inithasloaded &&
        <Group position="center" >
        <Alert variant="filled" color="red" title= {intl.get('ERROR_PARTICIPANT')} icon={icon}>
        {intl.get('ERROR_PARTICIPANT_TEXT')}
    </Alert>
    </Group>
       }
      </Grid.Col>  
            </Grid>
    </ Container>
    
    
    }


    
    </> 
  );
  
}


export default NotarDash;